module.exports = __webpack_public_path__ + "img/Bougies_led.e17b220.jpg";